export default "__VITE_ASSET__9791cfc6__"